<script>
  import {
    defaultChainStore,
    web3,
    selectedAccount,
    connected,
    chainData,
  } from "svelte-web3";
  import Menu from "./Menu.svelte";

  let showAccountDropdown = false;
  let showMenu = false;

  const login = () => defaultChainStore.setBrowserProvider();
  const logout = () => defaultChainStore.close();

  const toggleShowMenu = () => (showMenu = !showMenu);

  const toggleAccountDropdown = () =>
    (showAccountDropdown = !showAccountDropdown);

  $: checkAccount =
    $selectedAccount || "0x0000000000000000000000000000000000000000";
  $: checkAccountShort = checkAccount.slice(0, 8) + "...";
  $: balance = $connected ? $web3.eth.getBalance(checkAccount) : "";
</script>

<div id="header" class="bg-gray-900">
  <div class="left">
    <button id="menu" class=" p-2 px-4" on:click={toggleShowMenu}
      ><img
        src="img/burger_menu.svg"
        alt="menu"
        width="25px"
        height="25px"
      /></button
    >
    <h1 class="text-white p-2 px-4 text-3xl font-black pl-0">PixelCollab</h1>
  </div>
  <div class="right">
    {#if $selectedAccount}
      <button
        id="account"
        class="btn btn-primary text-black bg-white p-2 px-4"
        on:click={toggleAccountDropdown}
        ><div class="connected-icon" />
        {checkAccountShort}
        {#if showAccountDropdown}
          <nav>
            <ul>
              <li><button on:click={logout}> Disconnect </button></li>
            </ul>
          </nav>
        {/if}
      </button>
    {:else}
      <button
        id="login"
        class="btn btn-primary text-black bg-white p-2 px-4"
        on:click={login}
        ><img
          src="img/MetaMask_Fox.svg"
          alt="metamask"
          width="20px"
          height="20px"
        />Connect</button
      >
    {/if}
  </div>
  {#if showMenu}
    <button id="menu-close" class=" p-2 px-4" on:click={toggleShowMenu}
      ><img src="img/close.svg" alt="menu" width="35px" height="35px" /></button
    >
    <Menu />
  {/if}
</div>

<style>
  #header {
    position: absolute;
    width: 100vw;
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  #account {
    width: 150px;
  }
  #menu-close {
    position: absolute;
    top: 0;
    left: 0;
    color: white !important;
    z-index: 51;
  }
  .connected-icon {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: rgb(12, 207, 12);
  }

  .right {
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
  }

  .left {
    display: flex;
  }

  .right nav {
    position: absolute;
    top: 0;
    margin-top: 40px;
    right: 0;
    background-color: white;
    padding: 10px;
    width: 150px;
  }

  button {
    display: flex;
    align-items: center;
    gap: 5px;
  }
</style>
